module.exports = __webpack_public_path__ + "img/1507738266.ded43436.jpg";